import { FC } from 'react';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types/swiper-options';
import styles from './business-hub-used-by.module.scss';
import UsedByItem, { UsedByItemProps } from './used-by-item/used-by-item';

SwiperCore.use([Autoplay]);

const options: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 30,
    allowTouchMove: true,
    loop: true,
    speed: 1000,

    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },

    breakpoints: {
        992: {
            spaceBetween: 60,
            slidesPerView: 'auto',
            autoplay: false,
            loop: false,
        },

        575: {
            slidesPerView: 2,
        },
    },
};

export interface BusinessHubUsedByProps {
    listItem: UsedByItemProps[];
    title?: string;
    subTitle?: string;
}

const BusinessHubUsedBy: FC<BusinessHubUsedByProps> = (props) => {
    const { title, subTitle, listItem } = props;

    return (
        <div className={styles.container}>
            <div className={styles.wrapperContent}>
                <div
                    className={styles.title}
                    dangerouslySetInnerHTML={{
                        __html: title || '',
                    }}
                ></div>
                {subTitle && (
                    <div
                        className={styles.subTitle}
                        dangerouslySetInnerHTML={{
                            __html: subTitle || '',
                        }}
                    ></div>
                )}

                <div className={styles.listItem}>
                    <Swiper {...options}>
                        {listItem
                            .sort((a, b) => (a.order || 0) - (b.order || 0))
                            .map((item, index) => {
                                return (
                                    <SwiperSlide key={Math.random()}>
                                        <div className={styles.item}>
                                            <UsedByItem key={Math.random()} {...item} />
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default BusinessHubUsedBy;
